import { memo } from 'react';
import { QuickActionFilter } from '../QuickActionFilter';
import { CompetitivenessFilter } from './CompetitivenessFilter';
import { CpiDaysFilter } from './CpiDaysFilter';
import { MarginFilter } from './MarginFilter';
import NewCostsFilter from './NewCostsFilter';
import { PriceVariationFilter } from './PriceVariationFilter';
import QuickActionPriceTypeFilter from './QuickActionPriceTypeFilter';
import StockQuantityFilter from './StockQuantityFilter';
import useGerenciadorQuickActionFilters from './useGerenciadorQuickActionFilters';

const { Select, Button } = QuickActionFilter;

const MemoCpiDaysFilter = memo(CpiDaysFilter);
const MemoMarginFilter = memo(MarginFilter);
const MemoPriceVariationFilter = memo(PriceVariationFilter);
const MemoCompetitivenessFilter = memo(CompetitivenessFilter);
const MemoStockQuantityFilter = memo(StockQuantityFilter);

const GerenciadorQuickActionFilters = () => {
  const filters = useGerenciadorQuickActionFilters();

  return (
    <QuickActionFilter>
      <Button {...filters.isFilterVisible} />
      <QuickActionPriceTypeFilter />
      <NewCostsFilter />
      <MemoCpiDaysFilter />
      <MemoStockQuantityFilter />
      <MemoPriceVariationFilter />
      <MemoCompetitivenessFilter />
      <MemoMarginFilter />
      {/* <Button {...filters.changedPrices} forceDisabled={false} /> */}
      <Select {...filters.selectLimits} />
      <Button {...filters.derrivedProducts} forceDisabled />
    </QuickActionFilter>
  );
};

export default memo(GerenciadorQuickActionFilters);
